module.exports = __webpack_public_path__ + "img/DS223.7d792878.png";